// @ts-nocheck

import { useSelector } from 'react-redux';

import { Panel } from '../components';
import { panelSelector } from '../selectors/panel';

const PanelContainer = (props) => {
  const selectedProps = useSelector((state) => panelSelector(state, props));

  return <Panel {...selectedProps} {...props} />;
};

export default PanelContainer;
